export default "__VITE_ASSET__DCzlU_nS__"